import script from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ErrorModal.vue?vue&type=script&lang=ts&setup=true"

import "./ErrorModal.vue?vue&type=style&index=0&id=47292cbc&lang=css"

const __exports__ = script;

export default __exports__